import __request__ from "routing/request";
export function licenseInfo(requestOptions) {
  return __request__("GET", "/enterprise/license/info", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
